// =============================
// File: src/Register.jsx (JSX)
// =============================
import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "";
const API_REGISTER = `${API}/api/register`;

export function Register() {
  const [searchParams] = useSearchParams();
  
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const role = "customer";
  const [referralCode, setReferralCode] = useState(searchParams.get('ref') || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setOk("");
    setLoading(true);
    try {
      const payload = {
        username,
        email,
        phone_number: phone,
        password,
        role,
        referral_code: referralCode.trim().toUpperCase()
      };
      const { status, data } = await axios.post(API_REGISTER, payload);
      if (status === 201) {
        setOk(data?.message || "Usuario creado. Revisa tu correo para verificar la cuenta antes de iniciar sesion.");
      } else {
        setError(data?.message || "Error al registrar");
      }
    } catch (err) {
      const msg = err?.response?.data?.message || "Error al registrar";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-sm border border-slate-200">
        <h1 className="text-2xl font-extrabold text-brand-primary">Crear cuenta</h1>
        <p className="mt-1 text-sm text-slate-600">
          Regístrate para empezar a enviar con Fast Max.
        </p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-medium">Nombre</label>
            <input
              className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-slate-200"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          
          <div>
            <label className="text-sm font-medium">Correo</label>
            <input
              type="email"
              className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-slate-200"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <div>
            <label className="text-sm font-medium">Teléfono</label>
            <input
              className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-slate-200"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </div>
          
          <div>
            <label className="text-sm font-medium">Contraseña</label>
            <input
              type="password"
              className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-slate-200"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {/* Referral Code Input */}
          <div>
            <label className="text-sm font-medium">
              Código de Referido <span className="text-slate-400">(Opcional)</span>
            </label>
            <input
              className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 uppercase focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-brand-primary"
              value={referralCode}
              onChange={(e) => setReferralCode(e.target.value)}
              placeholder="Ej: MAGIC2X9K"
              maxLength={20}
            />
            {referralCode && (
              <p className="mt-1 text-xs text-brand-green">
                🎉 ¡Recibirás 50% de descuento en tus primeros 10 envíos!
              </p>
            )}
          </div>

          {error && (
            <div className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700 border border-red-200">
              {error}
            </div>
          )}
          
          {ok && (
            <div className="rounded-lg bg-emerald-50 px-3 py-2 text-sm text-emerald-700 border border-emerald-200">
              {ok}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-xl px-4 py-2.5 font-semibold text-white shadow-sm disabled:opacity-60 bg-brand-primary hover:bg-brand-primary/90 transition-colors"
          >
            {loading ? "Creando…" : "Crear cuenta"}
          </button>
        </form>

        <div className="mt-4 text-sm text-slate-600">
          ¿Ya tienes cuenta?{" "}
          <Link to="/login" className="font-semibold underline underline-offset-4 text-brand-primary">
            Inicia sesión
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Register;
